/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
require('@fancyapps/fancybox');
require('jquery-parallax.js/parallax.js');

const VimeoPlayer = require('@vimeo/player');

// window.Headroom = require('headroom.js');
// import 'headroom.js/dist/jQuery.headroom'

import { Foundation } from './foundation';
import { WOW } from 'wowjs';
Foundation.addToJquery(jQuery);

/**
 *
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 *
 * Application script
 *
 */
$(function() {
    $(document).foundation();

    // Image tile accordions
    // $('.image-tile--accordion').off('click');

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.image-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.image-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.image-tile__content').slideToggle();
        });
    }

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.icon-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.icon-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.icon-tile__content').slideToggle();
        });
    }

    // Load Google map javascript
    if(document.querySelector('[data-maps-api-key]') && !document.querySelector('.gMapsAPI')){
        if($('[data-maps-api-key]').length){
            let script = document.createElement('script');
            const apiKey = $('[data-maps-api-key]:first').attr('data-maps-api-key');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initializeMaps';
            script.className = 'gMapsAPI';
            document.body.appendChild(script);
        }
    }

    // Banner Slideshow
    if($('.banner--slick').length > 0) {
        $('.banner--slick').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 800,
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            fade: true,
            dots:true
        }).on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
        });
    }

    // Gallery Slideshow
    if($('.gallery-slideshow__inner').length > 0) {
        var $status = $('.gallery-slideshow__pagination'),
            $slickElement = $('.gallery-slideshow__inner'),
            totalSlides,
            slidePosition,
            $currentImage = $('.gallery-slideshow .slick-current img');


        $('.gallery-slideshow__slide').each(function() {
            var currentImage = $(this).children('.gallery-slideshow__image'),
                imageWidth = $(currentImage).width(),
                imageText = $(this).children('.gallery-slideshow__text');
            $(imageText).width(imageWidth);
        });

        $slickElement.slick({
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            speed: 800
        });
    };


    // Gallery Carousel
    $('.gallery-carousel__slides').slick({
        lazyLoad: 'ondemand',
        setPosition: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: true,
        prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
        nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
        asNavFor: '.gallery-carousel__thumbs'
    });

    $('.gallery-carousel__thumbs').slick({
        lazyLoad: 'ondemand',
        setPosition: 0,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.gallery-carousel__images',
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        centerPadding: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    // Wowjs
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       0,                // distance to the element when triggering the animation (default is 0)
            mobile:       false,             // trigger animations on mobile devices (default is true)
            live:         false,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );
    wow.init();

    // Match height
    setTimeout(() => {
        $('.mh').matchHeight({
            byRow: true
        });
    }, 500);

    // Mega Menu
    $('body').on('click', '.mega-menu-control', function(e){
        var target = '#' + $(this).attr('open-box');

        if($(target).hasClass('open')){
            $(this).removeClass('open not-current');
            $(target).removeClass('open');
            $('.mega-menu-control').removeClass('not-current');
            // Bring in standard text
            $('.mega-menu-info-text').animate({'opacity' : 1}, 400);
        } else {
            $('.mega-menu-control').removeClass('open').addClass('not-current');
            $('.mega-menu-box').removeClass('open');
            $(this).addClass('open').removeClass('not-current');
            $(target).addClass('open');
            // Hide standard text
            $('.mega-menu-info-text').animate({'opacity' : 0}, 400);
        }
    });

    // Home Banner
    if($('.home-banner-carousel').length > 0){
        $('.home-banner-carousel').slick({
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            arrows: false,
            fade: true
        });

        function debounce(func){
            var timer;
            return function(event){
            if(timer) clearTimeout(timer);
                timer = setTimeout(func,100,event);
            };
        }

        // Resize to screensize
        function updateBannerSize(){
            if(Foundation.MediaQuery.atLeast('large')){
                var newHeight = $('.home-banner').first().outerHeight() - $('.home-banner .braid-video').first().outerHeight();
                if(newHeight > 0){
                    $('.home-banner .grid-x').height(newHeight);
                }
            } else {
                $('.home-banner .grid-x').height('auto');
            }
        }
        window.setTimeout(function(){
            updateBannerSize();
        }, 500);
        window.addEventListener("resize", debounce(function(e){
            updateBannerSize();
        }));
    }

    // Auto play video when menu revealed
    $("#mainNav").on("open.zf.reveal", function(e) {
        $('#mainNav .braid-video')[0].play();
    });

    /* Profiles */
    $('body').on('click', '.profile-btn, .profile__image', function(e){
        var parent = $(this).closest('.person');

        // Check the parent and open or close as needed
        if(parent.hasClass('is-open')){
            $('.person').removeClass('is-open');
        } else {
            $('.person').removeClass('is-open');
            parent.addClass('is-open');
        }
    });

    /*
    *   Fibre page
    */
    if($('.fibre-embed-map').length > 0){
        $('.fibre-embed-map').click(function(){
    		$(this).find('iframe').addClass('clicked');
        }).mouseleave(function(){
    		$(this).find('iframe').removeClass('clicked');
        });
    }

    if($('#Form_AddressFinderForm_AddressInput').length > 0){
        var widget,
            initAF = function() {
                widget = new AddressFinder.Widget(
                    document.getElementById("Form_AddressFinderForm_AddressInput"),
                    "YLX7G9TCWM4PK36NUFQD", //"ADDRESSFINDER_DEMO_KEY",
                    'NZ',
                    {
                        show_locations: false,
                        manual_style: true,
                        empty_content : "We have been unable to locate your address.",
                        address_params: {region_code: '3'}, /* region_code for Auckland is 1 */
                        location_params: {region_code: '3'},
                        "byline": false
                    }
                );

                // Add same width to address finder dropdown as search field
                $('.af_list').css('width', $('#Form_AddressFinderForm_AddressInput').outerWidth());

                const $search = $('#Form_AddressFinderForm_AddressInput');
                let currentSelectedAddress = $search.val();

                function clearCurrentSelectionIfRequired(){
                    // Check for undefined, so we don't do the clearing out every keystroke
                    // now that we are using input rather than changed event.
                    // Check against the currentSelectedAddress to check that
                    // we aren't clearing out valid data (this might also have been
                    // fixed be switching from change to input).
                    if(currentSelectedAddress !== undefined && $search.val() !== currentSelectedAddress){
                        currentSelectedAddress = undefined;
                    }
                }

                // if the search changes then clear out the selected icp stuff.
                // Use input rather than change as stuff like the delete button on the
                // input don't work as nicely with change.
                $search.on('input', function() {
                    clearCurrentSelectionIfRequired();
                });

                widget.on("result:select", function(fullAddress, metaData) {
                    var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData),
                        address = selected.metaData;

                    // Populate hidden fields
                    $('#Form_AddressFinderForm_StreetNumber').val(address.number + (typeof address.alpha !== 'undefined' ? address.alpha : ''));
                    $('#Form_AddressFinderForm_StreetName').val(address.street);
                    $('#Form_AddressFinderForm_Suburb').val(address.suburb);
                    $('#Form_AddressFinderForm_Region').val(address.region);
                    $('#Form_AddressFinderForm_LinzID').val(address.aims_address_id);
                });
           };

        // Initialise address finder field
        function downloadAF(f){
            var script = document.createElement('script');
            script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
            script.async = true;
            script.onload = f;
            document.body.appendChild(script);
        };
        // Call initialise function
        downloadAF(initAF);

        // Check fields before posting form
        $('#Form_AddressFinderForm').submit(function(e){
            // Check fields not empty
            // if($('#Form_AddressFinderForm_StreetNumber').val() == '' || $('#Form_AddressFinderForm_StreetName').val() == ''){
            //     return false;
            // }
            return true;
        });
    }

    // Isotope Filtering
    if($('.fibre-grid').length > 0){
        var imagesLoaded = require('imagesloaded');
        setTimeout(() => {
            imagesLoaded('.fibre-grid', function(){
                var isotope = require('isotope-layout'),
                    iso = new isotope('.fibre-grid', {
                        itemSelector: '.grid-item',
                        masonry: {
                            columnWidth: '.grid-item'
                        }
                    });

                if($('.fibre-grid-filters.filtered').length > 0){
                    var filterVal = $('.fibre-grid-filters.filtered').first().attr('data-filter');
                    iso.arrange({"filter" : filterVal});
                }

                $('body').on('click', '.fibre-grid-filters', function(e) {
                    var filterValue = $(this).attr('data-filter');
                    // Add class for styling
                    $('.fibre-grid-filters').removeClass('filtered');
                    $(this).addClass('filtered');
                    // Do the filtering
                    iso.arrange({"filter" : filterValue});
                });
            });
        }, 200);
    }


    // maybe button click to show the message
    const maybebtn = document.getElementById("maybebtn");
    maybebtn.addEventListener("click", showmsg);
    function showmsg(){
        maybebtn.classList.add('btn-clicked');
        var msg = document.getElementById("maybemsg");
        msg.style.display = "block";
    }


});



// WEBPACK FOOTER //
// ./themes/base/js/app.js